<template>
  <v-app>
    <SideMenu :alert="alert" :alert_type="alert_type" :message="message" submenuPage="Resource Type" submenuGroup="Service Setup">
      <List>
        <template v-slot:action-button>
          <v-btn
            color="primary"
            class="mr-4"
            @click="ResourceTypeCreateForm"
            v-if="staffPermission.createResourceType"
          >
            + New Resource Type
          </v-btn>
        </template>
        <template v-slot:tabs></template>
        <template v-slot:tab-items>
          <v-data-table
            :headers="headers"
            :items="resourceTypes"
            class="elevation-1"
            item-key="name"
          >
          <template v-slot:item="{ item }">
            <tr
              @click="ResourceTypeUpdateForm(item.id)"
              style="cursor:pointer"
            >
              <td><span class="dot" :style="{ backgroundColor: item.color }"></span> {{ item.name }}</td>
            </tr>
          </template>
          </v-data-table>
        </template>
      </List>
    </SideMenu>
  </v-app>
</template>

<style>
.dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
</style>

<script>
import SideMenu from '/src/components/SideMenu'
import List from '/src/components/List'
import gql from 'graphql-tag'
import * as queries from '@/graphql/gqlQueries.js';
  const GET_ALL_RESOURCES_QUERY = gql`
      query ResourceTypes {
        resourceTypes {
          id
          name
          created_at
          color
        }
      }
  `
  export default {
    name: 'Resource',

    components:{
      SideMenu,
      List
    },

    data () {
      
      return {
        resourceTypes: [],
        alert: this.$route.params.alert,
        alert_type: this.$route.params.alert_type,
        message: this.$route.params.message,

        headers:[
          {
            text: 'Name',
            value: 'name',
            class: 'white--text'
          }
        ],
        getAllPermissions: [],
        allPermissionsName: [],
        staffPermission: {},
      }
    },
    apollo: {
      resourceTypes: {
        query: GET_ALL_RESOURCES_QUERY,
        pollInterval: 300,
        async result(){
          const sortProperties = [
                    { property: 'id', direction: 'desc' },
                    { property: 'created_at', direction: 'desc' },
                ];

      // Use the multiPropertySort function to sort the commissionList
      this.resourceTypes = await this.$generalFunctions.multiPropertySort(this.resourceTypes, sortProperties);
        }
      },
    },
    methods: {
      ResourceTypeUpdateForm(id) {
        this.$router.push({ path: '/type/resource/'+id })
      },
      ResourceTypeCreateForm() {
        this.$router.push({ path: '/create/type/resource' })
      }
    },
    created(){
      this.$apollo.query({ query: queries.GET_ALL_PERMISSIONS_QUERY }).then(async result => {
        this.getAllPermissions = await result.data.getAllPermissions;
        this.$apollo.query(
          {
            query: queries.GET_STAFF_ROLES,
            variables: {
              staffId: this.$session.get("user_id") * 1
            }
          }
        ).then(async result => {
          this.getStaffRoles = await result.data.getStaffRoles;
          this.allPermissionsName = [];
          this.getStaffRoles.forEach(role => {
            role.role.RolePermission.forEach((item) => {
              const name = item.permission.name;
              this.allPermissionsName.push(name);
            });
          })
          this.$session.set('staffPermission', this.$generalFunctions.generatePermissionArray(this.getAllPermissions, this.allPermissionsName));
          this.staffPermission = await this.$generalFunctions.generatePermissionArray(this.getAllPermissions, this.allPermissionsName)
        })
      })
    }
  }
</script>
